import * as React from 'react';

import IcPersonGhost from 'common/components/svg/IcPersonGhost';

const sizeToKey = {
  sm: 56,
  md: 112,
  lg: 144,
  xl: 200,
};

export interface MediaImageProps {
  path?: string;
  size: string;
  height?: number;
  width?: number;
  alt?: string;
  style?: object;
  className?: string;
  fallback?: any; // React.ReactNode
}

export const MediaImage: React.SFC<MediaImageProps> = ({
  path,
  size,
  height,
  width,
  alt,
  className,
  style,
  fallback,
}) => {
  if (!path) {
    const w = sizeToKey[size];
    const h = sizeToKey[size];
    return fallback ? fallback : <IcPersonGhost width={w} height={h} className={className} style={style} />;
  }
  return (
    <img
      src={
        process.env.REACT_APP_MEDIA_URL +
        '/' +
        path.substring(0, path.lastIndexOf('.')) +
        `-${sizeToKey[size]}x${sizeToKey[size]}sq` +
        path.substring(path.lastIndexOf('.'))
      }
      height={height ? height : `${sizeToKey[size]}px`}
      width={width ? width : `${sizeToKey[size]}px`}
      alt={alt}
      style={style}
      className={className}
    />
  );
};

MediaImage.displayName = 'MediaImage';



// WEBPACK FOOTER //
// ./src/common/components/MediaImage.tsx